import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { alertActions, commonActions, certmngActions } from '../../../../store/actions'

const CertMngList = (props) => {
  const [userSeCd, setUserSeCd] = useState('')
  useEffect(() => {
    let userInfo = JSON.parse(localStorage.getItem('user'))
    setUserSeCd(userInfo?.payload?.userSeCd)
  }, [])

  const goApply = (crtfCd) => {
    if (userSeCd === '01') {
      return props.error({ title: '확인', message: '기업회원만 이용 가능한 화면입니다.' })
    }

    if (crtfCd === '01') {
      window.location.replace('/service/certapply/1/')
    }
  }

  return (
    <>
      <div className="pc-only">
        <div className="tbl-wrap">
          <table className="tbl-list">
            <caption>증명서 신청 목록_ 발급기관, 제목, 신청 항목으로 구성</caption>
            <colgroup>
              <col style={{ width: '23%' }} />
              <col style={{ width: '55%' }} />
              <col />
            </colgroup>
            <thead>
              <tr>
                <th scope="col">발급기관</th>
                <th scope="col">제목</th>
                <th scope="col">신청</th>
              </tr>
            </thead>
            <tbody>
              {props.data?.length > 0 ? (
                props.data?.map((certMngObj, index) => (
                  <tr key={index}>
                    <td>{certMngObj.crtfIssuInstNm}</td>
                    <td>{certMngObj?.crtfNm}</td>
                    <td>
                      {certMngObj?.applyYn === 'Y' && (
                        <button type="button" className="btn-primary md" onClick={() => goApply(certMngObj.crtfCd)}>
                          신청
                        </button>
                      )}
                      <button type="button" className="btn-secondary md" onClick={() => props.onCertmngDetail(certMngObj)}>
                        안내
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td className="center" colSpan={3}>
                    <div className="nodata">조회 결과가 없습니다.</div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="mobile-only">
        <ul className="list-board">
          {props.data?.length > 0 ? (
            props.data?.map((certMngObj, index) => (
              <li key={index}>
                <div className="info">
                  <p className="txt">{certMngObj.crtfIssuInstNm}</p>
                  <p className="tit">{certMngObj?.crtfNm}</p>
                </div>
                {certMngObj?.applyYn === 'Y' && (
                  <a href="#" className="btn-primary md" onClick={() => goApply(certMngObj.crtfCd)} style={{ marginLeft: '30%' }}>
                    신청
                  </a>
                )}
                <a href="#" className="btn-secondary md" onClick={() => props.onCertmngDetail(certMngObj)}>
                  안내
                </a>
              </li>
            ))
          ) : (
            <li>
              <div className="center" colSpan={3}>
                <div className="nodata">조회 결과가 없습니다.</div>
              </div>
            </li>
          )}
        </ul>
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certmngInfo: state.certmng?.certmngInfo,
  }
}

const actionCreators = {
  getCertmngInfo: certmngActions.getCertmngInfo,
  changeSearchInfo: certmngActions.changeSearchInfo,
  success: alertActions.success,
  readCertmngList: certmngActions.readCertmngList,
  getCommonCode: commonActions.getCommonCode,
  confirm: alertActions.confirm,
  error: alertActions.error,
}

export default connect(mapStateToProps, actionCreators)(CertMngList)
